module.exports = __webpack_public_path__ + "img/match_icon_play.65afaeaa.png";